import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const Layout = () => import('@/layout/index.vue')

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: 'Dashboard', icon: 'el-icon-s-home' }
      }
    ]
  }
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  store.commit('RESET_ROUTES')
}

function loadView(view) {
  return () => import(`@/views/${view}.vue`)
}

function mapDynamicRoutes(routeList) {
  return (routeList || []).map(r => ({
    path: r.path,
    component: Layout,
    meta: r.meta,
    children: (r.children || []).map(c => ({
      path: c.path,
      name: c.name,
      component: loadView(c.component),
      meta: c.meta
    }))
  }))
}

export async function ensureDynamicRoutes() {
  if (store.state.routesLoaded) return store.state.routes
  const request = (await import('@/utils/request')).default
  const res = await request.get('/system/getRouters', { skipAuthRedirect: true })
  const dynamicRoutes = mapDynamicRoutes(res.data)
  store.commit('SET_ROUTES', dynamicRoutes)
  router.addRoutes(dynamicRoutes)
  return dynamicRoutes
}

export function addDynamicRoutes(routes) {
  const dynamicRoutes = mapDynamicRoutes(routes)
  store.commit('SET_ROUTES', dynamicRoutes)
  router.addRoutes(dynamicRoutes)
}

router.beforeEach(async (to, from, next) => {
  const token = store.state.token

  if (to.path === '/login') {
    if (token) {
      try {
        await ensureDynamicRoutes()
        next({ path: '/dashboard', replace: true })
      } catch (e) {
        store.commit('CLEAR_AUTH')
        next()
      }
      return
    }
    next()
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (!store.state.routesLoaded) {
    try {
      await ensureDynamicRoutes()
      next({ ...to, replace: true })
    } catch (e) {
      store.commit('CLEAR_AUTH')
      next('/login')
    }
    return
  }

  next()
})

export default router
